<template>
    <vx-expandable-card>
        <template v-slot:content>
            <vx-label size="md">Requested by</vx-label>
            <div class="text-sm text-slate-700 mb-2">
                The customer request or ticket this change was made on. It is recorded in the voice change log with any change this save makes to the number's voice routing.
            </div>
            <vx-input
                v-model="requestedBy"
                size="lg"
                data-test="requested_by"
                :error="displayFirstError(validate.requestedBy)"
            ></vx-input>
        </template>
    </vx-expandable-card>
</template>

<script setup lang="ts">
import { VxExpandableCard, VxLabel, VxInput } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { maxLength } from '@vuelidate/validators';
import { displayFirstError } from '~/utils/validation';

const requestedBy = defineModel<string>({ default: '' });

const validate = useVuelidate(
    {
        requestedBy: {
            maxLength: maxLength(250),
        },
    },
    { requestedBy }
);
</script>
